// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"ModalHeader","modalHeader":"ModalHeader","Title":"Title","title":"Title","HorizontalRule":"HorizontalRule","horizontalRule":"HorizontalRule"};